/* eslint-disable func-names */
if (typeof window !== 'undefined') {
  window.Times = window.Times || {};
  window.Times.setGRXDataInLocalStorage = function(key, val) {
    if (typeof window !== 'undefined' && typeof localStorage === 'object') {
      const grxQueueArray = [];
      const grxQueue = JSON.parse(localStorage.getItem(key));
      if (grxQueue) {
        grxQueue.push(val);
      } else {
        grxQueueArray.push(val);
      }
      const finalData = grxQueue || grxQueueArray;
      const finalGrxDataString = JSON.stringify(finalData);
      localStorage.setItem(key, finalGrxDataString);
    }
  };
}

export default null;
